











































































import { Component, Prop, Vue, Mixins, Watch } from "vue-property-decorator";
// 混入
import tablePagination from "@/mixins/tablePagination";
import loading from "@/mixins/loading";
// 接口
import { FreightAdd } from "@/types/api/freight";
import { freightSelectByObj, freightDel } from "@/api/freight";
// 工具
import print from "@/utils/print";
import debounce from "@/utils/debounce";
import copy from "@/utils/deepCopy";

@Component
export default class Table extends Mixins(loading, tablePagination) {
  @Prop() provinces!: Array<any>;
  // 父组件传值
  tableData: Array<FreightAdd> = [];
  keyword: string = ""; // 搜索关键字
  popoverRegion: Array<string> = [];

  /**
   * 生命周期
   */
  mounted() {
    this.getData();
  }
  /**
   * 监听
   */
  @Watch("keyword")
  searchValue() {
    debounce(() => this.getData());
  }

  @Watch("provinces")
  setprovinces() {
    // 强制覆盖，触发Watchers执行re-render更新
    let data = copy(this.tableData);
    data.forEach((e: any) => {
      e.regionName = this.exchangeRegion(e.region);
    });
    this.tableData = data;
  }
  /**
   * methods
   */
  getData() {
    this.showLoading();
    freightSelectByObj({
      templeName: this.keyword,
    }).then((res: any) => {
      let data = res.data;
      let list: any;
      list = data.reduce((pre: any, cur: FreightAdd) => {
        // 查看是否存在
        let index: number = pre.findIndex(
          (f: FreightAdd) => f.templateCode == cur.templateCode
        );
        // 存在则在当前对象内容添加
        if (index > -1) {
          pre[index].region += "," + cur.region; // 地区code拼接
          pre[index].data.push({
            region: cur.region,
            continueFee: cur.continueFee,
            continueValue: cur.continueValue,
            firstFee: cur.firstFee,
            firstValue: cur.firstValue,
          });
        } else {
          // 不存在则添加
          pre.push({
            ...cur,
            data: [
              {
                region: cur.region,
                continueFee: cur.continueFee,
                continueValue: cur.continueValue,
                firstFee: cur.firstFee,
                firstValue: cur.firstValue,
              },
            ],
          });
        }
        return pre;
      }, []);
      // 将id转成为中文名称
      list.forEach((e: any) => {
        e.regionName = this.exchangeRegion(e.region);
      });
      this.tableData = copy(list);
      this.total = list.length;
      this.hideLoading();
    });
  }
  // 修改
  handleEdit(row: any) {
    this.$emit("edit", row);
  }
  // 删除
  handleDelete(row: any) {
    this.$confirm("是否要删除该模板?", "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      freightDel({ id: row.templateCode }).then((res: any) => {
        this.$message({
          type: "success",
          message: "删除成功!",
        });
        this.getData();
      });
    });
  }
  // id转成成名称
  exchangeRegion(region: any): Array<string> {
    let arr = region.split(",");
    let list: any = [];
    this.provinces.map((e: any) => {
      arr.map((a: number) => {
        if (a == e.id) {
          list.push(e.name);
        }
      });
    });
    // 当所有内容都不匹配，则显示原始内容
    if (list.length == 0) {
      list = arr;
    }
    return list;
  }
}
